<template>
  <div class="col-sm-12">
    <div class="navigation-links">
      <router-link to="/dashboard" class="btn btn-secondary">
        <font-awesome-icon icon="home" /> Volver
      </router-link>
    </div>
		<survey-list :surveys="surveys"/>
  </div>
</template>

<script>

	// @ is an alias to /src
  import SurveyService from "@/services/survey.service";
  import SurveyList from "@/components/surveys/SurveyList.vue";

	export default {
	  	name: 'Dashboard',
      data() {
        return {
            surveys: []
          }
      },
	  	components: {
	      SurveyList
	    },
      methods: {
        getSurveys() {
          SurveyService.findAll().then(
              response => {
                this.surveys = response.data
              },
              error => {
                console.log((error.response && error.response.data) ||
                error.message ||
                error.toString())
              }
          );
        }
      },
      mounted() {
        this.getSurveys();
      }
	};

</script>

<style scoped>
</style>